import { t } from "i18next"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"

import nextIcon from "../../../assets/common/next_pagination.svg"
import previousIcon from "../../../assets/common/previous_pagination.svg"
import { pageOptions, pageOptions12Grid,pageOptions9Grid } from "../../../utils/Constant"
import Dropdown from "../Form/DropdownWithSetValueSupport"

const DOT_SELECTER = "..."

const Pagination = (props) => {
    const { PaginationState, totalrecords, onPaginationClicked, pageSize, setPageSize, pageindex, paginationClickedHelper, isPaginationChangedDropdown = false, page12Grid = false, page9Grid = false   } = props
    const [perPage, setPerPage] = useState(pageSize)
    const [currentPage, setCurrentPage] = useState(1)
    const length= totalrecords 
    const totalnoOfPages = useMemo(() => {
        return Math.ceil(length / pageSize)
    }, [length, pageSize])
    const [visiblePages, setVisiblePages] = useState([])

    useEffect(() => {
        const pages = getVisiblePages(PaginationState.pageIndex, totalnoOfPages)
        setVisiblePages(pages)
    }, [totalnoOfPages])


    const getVisiblePages = (page, total) => {
        const pages = []
        const pagesToShow = 4 // Minimum number of pages to display

        if (total <= pagesToShow) {
            // Show all pages if total pages fit within the limit
            for (let i = 1; i <= total; i++) {
                pages.push(i)
            }
        } else {
            // Always show the first page
            pages.push(1)

            if (page > pagesToShow - 2) {
                // Add leading dots if current page is beyond the initial range            
                pages.push(DOT_SELECTER)
            }

            const start = Math.max(2, Math.min(page - 1, total - (pagesToShow - 2)))
            const end = Math.min(total - 1, start + (pagesToShow - 2))

            for (let i = start; i <= end; i++) {
                pages.push(i)
            }

            if (page < total - (pagesToShow - 3)) {
                // Add trailing dots if the range does not include the last page
                pages.push(DOT_SELECTER)
            }

            // Always show the last page
            pages.push(total)
        }

        return pages
    }

    const changePage = (page) => {
        if (page === DOT_SELECTER) return // Ignore dots
        const pages = getVisiblePages(page, totalnoOfPages)
        setVisiblePages(pages)
        onPaginationClicked(page)
        setCurrentPage(page)
    }

    useEffect(() => {
        setPageSize(Number(perPage))
    }, [perPage, setPageSize])

    useEffect(() => {
        setPageSize(Number(perPage))
    }, [pageindex])

    const getCurrentRecordCount = () => {
        const currentIndex = currentPage
        const currentpageSize = pageSize
        if (currentIndex == 1) {
            return `1 - ${currentpageSize}`
        }
        const startRecord = (currentIndex * currentpageSize + 1) - currentpageSize
        const endRecord = (currentIndex * currentpageSize) <= length ?
            (currentIndex * currentpageSize) : length
        return `${startRecord} - ${endRecord}`
    }
    const  resultPerPageChange = (e) => {
        const value = e?.value || "" // Dropdown value 
        setPerPage(value)
        setPageSize(parseInt(value))
        setCurrentPage(1)
        onPaginationClicked(1, value)
        isPaginationChangedDropdown && paginationClickedHelper()
    }

    const dropdownFilter = (dropdownValues) => {
        // Extract only the value properties for comparison
        let values = dropdownValues.map(item => item.value)    
        // Find the next higher value
        let nextHigher = values.find(value => value >= totalrecords)    
        // Filter values up to the next higher threshold
        let filteredValues = dropdownValues.filter(item => item.value <= totalrecords || item.value === nextHigher)     
        return filteredValues
    }

    return (  
           
        (page12Grid ? totalrecords > 12 : page9Grid ? totalrecords > 9 :  totalrecords > 10) &&   (<div className="flex flex-col justify-center items-center gap-[10px] slef-stretch">
            <div className="relative w-full flex flex-row justify-center items-center">
                <div className="flex items-center gap-[8px]">
                    <span className="text-xs font-lighter text-secondary-200 pr-2">
                        { t("common.paginationResultText") }
                    </span>
                    <div className="flex w-[100px] flex-col items-start pr-2">
                        <Dropdown
                            placeholder=""
                            options={ page12Grid ? dropdownFilter(pageOptions12Grid) : page9Grid ? dropdownFilter(pageOptions9Grid) : dropdownFilter(pageOptions) }
                            name="pageSize"
                            value={ pageSize }
                            changeHandler={ (e)=> resultPerPageChange(e) }
                            isNotRequired={ true }
                            menuPlacement="top"
                        />
                    </div>
                    <span className="text-xs font-lighter text-secondary-200 ppagi-4 pr-4">
                        { `${getCurrentRecordCount()} ${t("common.paginationBetweenLabel")} ${totalrecords}` }
                    </span>
                </div>
                {   (totalrecords > pageSize && pageSize) &&    <div className="flex items-center gap-[8px]">
                    { /* Previous Button */ }
                    <button
                        type="button"
                        className="page_button_previous text-primary-100 h-99 w-102 fill-current 
                    rounded-full hover:border-0 hover:bg-primary-150 items-center flex justify-center m-1.5 p-4"
                        disabled={ PaginationState.pageIndex <= 1 }
                        onClick={ () => changePage(PaginationState.pageIndex - 1) }
                    >
                        <img
                            alt="previous"
                            src={ previousIcon }
                            className="max-w-none"
                            height={ "16px" }
                            width={ "16px" }
                        />
                    </button>

                    { /* Page Numbers */ }
                    { visiblePages.map((page, index) => (
                        <button
                            key={ `page_${index}` }
                            type="button"
                            className={ `page_button_${page} text-primary-100 h-99 w-102 fill-current 
                          border-b-2 border-transparent hover:border-primary-100 items-center flex justify-center m-1.5 p-4 ${page === PaginationState.pageIndex
                            ? "border-b-2 !border-primary-100"
                            : ""
                        } ${(page === DOT_SELECTER) && "!bg-transparent"}` }
                            onClick={ () => changePage(page) }
                            disabled={ page === DOT_SELECTER }
                        >
                            { page }
                        </button>
                    )) }

                    { /* Next Button */ }
                    <button
                        type="button"
                        className={ "text-primary-100 h-99 w-102 fill-current rounded-full hover:border-0" +
                        " hover:bg-primary-150 items-center flex justify-center m-1.5 p-4"
                        }
                        disabled={ PaginationState.pageIndex >= totalnoOfPages }
                        onClick={ () => changePage(PaginationState.pageIndex + 1) }
                    >
                        <img
                            alt="next"
                            src={ nextIcon }
                            className="max-w-none"
                            height={ "16px" }
                            width={ "16px" }
                        />
                    </button>
                </div> }
            </div>
        </div>)
       
    )
}

Pagination.propTypes = {
    PaginationState: PropTypes.shape({
        pageIndex: PropTypes.number.isRequired,
        pageSize: PropTypes.number.isRequired
    }).isRequired,
    totalrecords: PropTypes.number.isRequired,
    onPaginationClicked: PropTypes.func.isRequired
}

export default Pagination
